
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/components/[...slug]",
      function () {
        return require("private-next-pages/docs/components/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/components/[...slug]"])
      });
    }
  